import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { SoftwareData } from '../software.model';
import { SoftwareActions, SoftwareActionTypes } from '../actions/software.actions';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function reducer(
  state = initialState,
  action: SoftwareActions
): State {
  switch (action.type) {

    case SoftwareActionTypes.GetSoftwareVersionData: {
      return { ...state, Loaded: false, Loading: true };
    }

    case SoftwareActionTypes.UpsertSoftwareVersionData: {
      return { ...state, Loaded: true, Loading: false, entities: action.payload };
    }

    case SoftwareActionTypes.GetSoftwareVersionDataFail: {
      return { ...state, Loaded: true, Loading: false, entities: action.payload };
    }

    default: {
      return state;
    }
  }
}

export const getSoftwareState = (state: State) => state;
